export const IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_FROM_PCG_ENTRIES =
  'immobilisation_compare_total_accounting_with_total_module_from_pcg_entries';
export const IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_VNC =
  'immobilisation_compare_total_accounting_with_total_module_vnc';
export const IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_FROM_CESSION =
  'immobilisation_compare_total_accounting_with_total_module_cession';

export const IMMOBILISATION_CONSISTENCY_CHECK_CODES = [
  IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_FROM_PCG_ENTRIES,
  IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_VNC,
  IMMOBILISATION_COMPARE_TOTAL_ACCOUNTING_WITH_TOTAL_MODULE_FROM_CESSION
] as const;
export type ImmobilisationConsistencyCheckCodes = (typeof IMMOBILISATION_CONSISTENCY_CHECK_CODES)[number];
